<template>
    <div>
        <v-dialog v-model="abrir" persistent max-width="50%" >
            <v-card class="pb-1">
                <v-card-title class="justify-space-between">
                    <span class="headline">{{ readonly ? 'Editar roles' : 'Crear menú'}}</span>
                    <v-btn color="red darken-1" dark @click="cerrarModal()">Cerrar</v-btn>
                </v-card-title>
                
                <v-col cols="12" class="mt-2 mb-4">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="texto"
                                label="Texto menú"
                                class="pt-1 mb-1" 
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="ruta"
                                label="Ruta"
                                class="pt-1 mb-1"
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="icono"
                                label="Icono"
                                class="pt-1 mb-1" 
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="orden"
                                label="Orden"
                                class="pt-1 mb-1"
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="debajo_de"
                                label="Debajo de"
                                class="pt-1 mb-1" 
                                :readonly="readonly"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                :items="roles"
                                item-text="name"
                                item-value="id"
                                v-model="roles_seleccionados"
                                multiple
                                small-chips
                                label="Roles"
                                class="pt-1 mb-1" 
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-row>
                    <v-progress-linear 
                        v-if="progreso"
                        indeterminate
                        color="#0D47A1"
                    ></v-progress-linear>
                </v-row>
                <div class="d-flex justify-center pt-5 pb-4">
                    <v-btn color="blue darken-1" dark @click="crearMenu" v-if="!readonly">Crear</v-btn>
                    <v-btn color="blue darken-1" dark @click="modificarRoles" v-if="readonly">Modificar roles</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    data:() => ({
        id: 0,
        texto: '',
        ruta: '',
        icono: '',
        orden: 0,
        debajo_de: 0,
        roles: [],
        roles_seleccionados: [],
        abrir: false,
        progreso: false,
        readonly: false,
    }),
    mounted() {
        this.$parent.$on('abrir_modal_create', ([roles, item]) => {
            if(item) {
                this.readonly = true;
                this.id = item.id;
                this.texto = item.texto;
                this.ruta = item.ruta;
                this.icono = item.icono;
                this.orden = item.orden;
                this.debajo_de = item.debajo_de;
                this.roles_seleccionados = item.roles;
            } else {
                this.id = 0;
                this.readonly = false;
                this.limpiarCampos();
            }
            this.roles = roles;
            this.abrir = true;
        });
    },
    methods: {
        async crearMenu() {
            this.mostrarLoading({ titulo: "Creando menú...", color:'green' });
            this.progreso = true;

            const data = { 
                texto: this.texto,
                ruta: this.ruta,
                icono: this.icono,
                orden: this.orden,
                debajo_de: this.debajo_de,
                roles: this.roles_seleccionados,
            };

            const url = `${this.base_url}menu/grabar_menu`;

            await this.axios.post(url, data, this.headers).then(res => {
                console.log("Menú creado exitosamente", res.data.data);
                this.ocultarLoading();
                this.cerrarModal(true);

                this.limpiarCampos();
            }).catch(e => {
                this.errorMessage(e, "Error al crear menú");
            });
            this.progreso = false;
        },
        async modificarRoles() {
            this.mostrarLoading({ titulo: "Modificando roles...", color:'green' });
            this.progreso = true;

            const data = { 
                texto: this.texto,
                roles: this.roles_seleccionados,
            };

            const url = `${this.base_url}menu/grabar_menu/${this.id}`;

            await this.axios.post(url, data, this.headers).then(res => {
                console.log("Roles modificados exitosamente", res.data.data);
                this.ocultarLoading();
                this.cerrarModal(true);

                this.limpiarCampos();
            }).catch(e => {
                this.errorMessage(e, "Error al modificar roles");
            });
            this.progreso = false;
        },
        limpiarCampos() {
            // Limpia inputs
            this.texto = '';
            this.ruta = '';
            this.icono = '';
            this.orden = 0;
            this.debajo_de = 0;
            this.roles_seleccionados = [];
        },
        cerrarModal(cargarDatos = false) {
            if(cargarDatos) {
                this.$emit('cargar_menus');
            }
            this.abrir = false;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
      ...mapState(['base_url', 'headers']),
    },
}
</script>

<style scoped>
</style>